import * as React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const NavItem = props => {
  const pageURI = window.location.pathname + window.location.search;
  const liClassName = props.path === pageURI ? 'nav-item active' : 'nav-item';
  const aClassName = props.disabled
    ? 'nav-link nav-link-collapse disabled'
    : 'nav-link nav-link-collapse';


    // ! Hard code the style, change later
  return (
    <ul className={liClassName} style={{padding: '0'}}>

      <Link className={aClassName} style={{color: 'white'}} to={props.path}>
        <FormattedMessage id={props.name} />
        {props.path === pageURI ? (
          <span className='sr-only'>(current)</span>
        ) : null}
      </Link>
    </ul>
  );
};

export default NavItem;



// WEBPACK FOOTER //
// ./src/components/navigation/navItem.tsx